var map = {
	"./ac.svg": "2878",
	"./ad.svg": "ecc7",
	"./ae.svg": "048f",
	"./af.svg": "fac6",
	"./afar.svg": "4047",
	"./ag.svg": "38cb",
	"./ai.svg": "5653",
	"./al.svg": "5cf4",
	"./am.svg": "e428",
	"./ao.svg": "88dc",
	"./aq.svg": "e2e7",
	"./ar.svg": "f651",
	"./as.svg": "c910",
	"./at.svg": "906e",
	"./au-aboriginal.svg": "6d0b",
	"./au-act.svg": "2474",
	"./au-nsw.svg": "04e0",
	"./au-nt.svg": "cf4d",
	"./au-qld.svg": "1c25",
	"./au-sa.svg": "8fc4",
	"./au-tas.svg": "d58e",
	"./au-vic.svg": "70c3",
	"./au-wa.svg": "0624",
	"./au.svg": "b9ef",
	"./aw.svg": "a9a4",
	"./ax.svg": "9b92",
	"./az.svg": "3611",
	"./ba.svg": "4390",
	"./bb.svg": "008b",
	"./bd.svg": "c337",
	"./be.svg": "bd48",
	"./bf.svg": "4f58",
	"./bg.svg": "a41b",
	"./bh.svg": "7f3c",
	"./bi.svg": "c920",
	"./bj.svg": "fbf8",
	"./bl.svg": "c3a1",
	"./bm.svg": "95e5",
	"./bn.svg": "5d50",
	"./bo.svg": "4638",
	"./bq-bo.svg": "1aaf",
	"./bq-sa.svg": "6bc0",
	"./bq-se.svg": "4402",
	"./bq.svg": "da06",
	"./br.svg": "93c7",
	"./bs.svg": "c96f",
	"./bt.svg": "87df",
	"./bv.svg": "fb8b",
	"./bw.svg": "8efc",
	"./by.svg": "eee4",
	"./bz.svg": "6da5",
	"./ca-bc.svg": "4e4d",
	"./ca.svg": "61d5",
	"./cc.svg": "db0a",
	"./cd.svg": "e436",
	"./cf.svg": "86de",
	"./cg.svg": "4609",
	"./ch-gr.svg": "17a5",
	"./ch.svg": "903d",
	"./ci.svg": "821f",
	"./ck.svg": "f269",
	"./cl.svg": "5618",
	"./cm.svg": "eae5",
	"./cn-xj.svg": "e52b",
	"./cn.svg": "35e6",
	"./co.svg": "60ef",
	"./cp.svg": "e347",
	"./cq.svg": "e833",
	"./cr.svg": "716a",
	"./cu.svg": "1d40",
	"./cv.svg": "0937",
	"./cw.svg": "fd67",
	"./cx.svg": "8a91",
	"./cy.svg": "7e9b",
	"./cz.svg": "177d",
	"./de.svg": "7e20",
	"./dg.svg": "dce7",
	"./dj.svg": "1ecd",
	"./dk.svg": "b1f9",
	"./dm.svg": "a7cf",
	"./do.svg": "eb24",
	"./dz.svg": "150b",
	"./ea.svg": "0278",
	"./earth.svg": "56e8",
	"./east_african_federation.svg": "3103",
	"./easter_island.svg": "4f13",
	"./ec-w.svg": "9429",
	"./ec.svg": "269f",
	"./ee.svg": "0e38",
	"./eg.svg": "2c39",
	"./eh.svg": "7ebd",
	"./er.svg": "21b7",
	"./es-ar.svg": "6ff5",
	"./es-ce.svg": "08c9",
	"./es-cn.svg": "10cd",
	"./es-ct.svg": "80a4",
	"./es-ga.svg": "7623",
	"./es-ib.svg": "e9b2",
	"./es-ml.svg": "bb03",
	"./es-pv.svg": "c954",
	"./es-variant.svg": "b947",
	"./es.svg": "2bcf",
	"./et-or.svg": "33bd",
	"./et-ti.svg": "056c",
	"./et.svg": "ff97",
	"./eu.svg": "db63",
	"./european_union.svg": "af18",
	"./ewe.svg": "3109",
	"./fi.svg": "c70c",
	"./fictional/klingon.svg": "923d",
	"./fj.svg": "5490",
	"./fk.svg": "1dca",
	"./fm.svg": "23a5",
	"./fo.svg": "bff2",
	"./fr-20r.svg": "20de",
	"./fr-bre.svg": "8b8a",
	"./fr-cp.svg": "6d48",
	"./fr.svg": "4b32",
	"./fx.svg": "055e",
	"./ga.svg": "f0dd",
	"./gb-con.svg": "384b",
	"./gb-eng.svg": "aaa1",
	"./gb-nir.svg": "e672",
	"./gb-ork.svg": "251f",
	"./gb-sct.svg": "6abb",
	"./gb-wls.svg": "bdf5",
	"./gb.svg": "02c1",
	"./gd.svg": "c00a",
	"./ge-ab.svg": "844e",
	"./ge.svg": "25654",
	"./gf.svg": "235c",
	"./gg.svg": "7acf",
	"./gh.svg": "1bb7",
	"./gi.svg": "0ee4",
	"./gl.svg": "62b0",
	"./gm.svg": "9bf25",
	"./gn.svg": "5b24",
	"./gp.svg": "8068",
	"./gq.svg": "b585",
	"./gr.svg": "fcdf",
	"./gs.svg": "6f9c",
	"./gt.svg": "c80a",
	"./gu.svg": "d5de",
	"./guarani.svg": "f1e9",
	"./gw.svg": "49b8",
	"./gy.svg": "eb65",
	"./hausa.svg": "520f",
	"./hk.svg": "b496",
	"./hm.svg": "4370",
	"./hmong.svg": "71ef",
	"./hn.svg": "cce3",
	"./hr.svg": "0f8a",
	"./ht.svg": "7b6c",
	"./hu.svg": "acb0",
	"./ic.svg": "9bee",
	"./id-jb.svg": "f491",
	"./id-jt.svg": "5bf7",
	"./id.svg": "2358",
	"./ie.svg": "2a70",
	"./il.svg": "3c23",
	"./im.svg": "0fa4",
	"./in-as.svg": "501b",
	"./in-gj.svg": "f4cc",
	"./in-ka.svg": "59dd",
	"./in-or.svg": "8c4e6",
	"./in-tg.svg": "71b2",
	"./in-tn.svg": "10fa",
	"./in.svg": "e813",
	"./io.svg": "1ede",
	"./iq.svg": "eacc",
	"./ir.svg": "d44f",
	"./is.svg": "3c56",
	"./it-23.svg": "3d28",
	"./it-82.svg": "7b35",
	"./it-88.svg": "82df",
	"./it.svg": "fe62",
	"./je.svg": "5e66",
	"./jm.svg": "ec05",
	"./jo.svg": "fc25",
	"./jp.svg": "d85a",
	"./kanuri.svg": "745e",
	"./ke.svg": "ab1e",
	"./kg.svg": "8a53",
	"./kh.svg": "b1b3",
	"./ki.svg": "a6c9",
	"./kikuyu.svg": "f263",
	"./km.svg": "a911",
	"./kn.svg": "3795",
	"./kongo.svg": "012d",
	"./kp.svg": "74f0",
	"./kr.svg": "ef33",
	"./kurdistan.svg": "fad3",
	"./kw.svg": "6b3c",
	"./ky.svg": "7f93",
	"./kz.svg": "141f",
	"./la.svg": "9a8d",
	"./language/aa.svg": "b721",
	"./language/ab.svg": "2868",
	"./language/af.svg": "939c",
	"./language/ak.svg": "6459",
	"./language/am.svg": "f600",
	"./language/an.svg": "3b6f",
	"./language/ar.svg": "a280",
	"./language/as.svg": "c8f4",
	"./language/av.svg": "2936",
	"./language/ay.svg": "edaf",
	"./language/az.svg": "e8cb",
	"./language/ba.svg": "052e",
	"./language/be.svg": "388d",
	"./language/bg.svg": "1804",
	"./language/bi.svg": "1c8b",
	"./language/bm.svg": "d86f",
	"./language/bn.svg": "cedb",
	"./language/bo.svg": "9a4a7",
	"./language/br.svg": "5e81",
	"./language/bs.svg": "2f52",
	"./language/ca.svg": "4042",
	"./language/ce.svg": "8ffb",
	"./language/ceb.svg": "8291",
	"./language/ch.svg": "0b32",
	"./language/chm.svg": "0192",
	"./language/ckb.svg": "2b95",
	"./language/co.svg": "1201",
	"./language/cs.svg": "a976",
	"./language/cv.svg": "b083",
	"./language/cy.svg": "1644",
	"./language/da.svg": "bf4a",
	"./language/de.svg": "3887",
	"./language/dv.svg": "e97b",
	"./language/dz.svg": "09dd",
	"./language/ee.svg": "ff8c",
	"./language/el.svg": "bd9b",
	"./language/en-au.svg": "7c04a",
	"./language/en-ca.svg": "9b93",
	"./language/en-in.svg": "8a94",
	"./language/en-ng.svg": "fa86",
	"./language/en-nz.svg": "289f",
	"./language/en-us.svg": "f6f9",
	"./language/en-za.svg": "ae34",
	"./language/en.svg": "49d8",
	"./language/eo.svg": "2825",
	"./language/es.svg": "762b",
	"./language/et.svg": "40c5",
	"./language/eu.svg": "0f47",
	"./language/fa.svg": "7a15",
	"./language/fi.svg": "7371",
	"./language/fj.svg": "707b",
	"./language/fo.svg": "148d",
	"./language/fr.svg": "7da3",
	"./language/fy.svg": "0bba",
	"./language/ga.svg": "ced3",
	"./language/gd.svg": "eb71",
	"./language/gl.svg": "25e7",
	"./language/gn.svg": "4aa7",
	"./language/gu.svg": "a2c77",
	"./language/gv.svg": "0cdd",
	"./language/ha.svg": "5bc9",
	"./language/haw.svg": "2fc2",
	"./language/he.svg": "40c2",
	"./language/hi.svg": "83f4",
	"./language/hmn.svg": "2ac0",
	"./language/ho.svg": "933d",
	"./language/hr.svg": "4bcd",
	"./language/ht.svg": "5f4f",
	"./language/hu.svg": "9b05",
	"./language/hy.svg": "f210",
	"./language/ia.svg": "d0ba",
	"./language/id.svg": "0d54",
	"./language/ie.svg": "1d29",
	"./language/ig.svg": "7db9",
	"./language/ilo.svg": "7e2d",
	"./language/interslavic.svg": "efc7",
	"./language/io.svg": "413a",
	"./language/is.svg": "b908",
	"./language/it.svg": "8010",
	"./language/ja.svg": "6078",
	"./language/jv.svg": "aaef",
	"./language/ka.svg": "2c3ea",
	"./language/kg.svg": "9d50",
	"./language/ki.svg": "f80c",
	"./language/kk.svg": "c3c2",
	"./language/kl.svg": "f121",
	"./language/km.svg": "02d4",
	"./language/kn.svg": "dcb1",
	"./language/ko.svg": "2732",
	"./language/kr.svg": "849f",
	"./language/kri.svg": "d48c",
	"./language/ks.svg": "2b50",
	"./language/ku.svg": "aec3",
	"./language/kv.svg": "99da",
	"./language/kw.svg": "b711",
	"./language/ky.svg": "83e8",
	"./language/la.svg": "d74a",
	"./language/lb.svg": "879f",
	"./language/lg.svg": "9502",
	"./language/ln.svg": "5663",
	"./language/lo.svg": "f404",
	"./language/lt.svg": "d2f2",
	"./language/lu.svg": "2155",
	"./language/lus.svg": "abfa",
	"./language/lv.svg": "a6a0",
	"./language/mg.svg": "ba38",
	"./language/mh.svg": "2d5d",
	"./language/mi.svg": "4db2",
	"./language/mk.svg": "246b",
	"./language/ml.svg": "241f",
	"./language/mn.svg": "aaa6",
	"./language/mni.svg": "8939",
	"./language/mr.svg": "51ee",
	"./language/mrj.svg": "8382",
	"./language/ms.svg": "845a",
	"./language/mt.svg": "c881",
	"./language/my.svg": "128b",
	"./language/na.svg": "a487",
	"./language/nb.svg": "6876",
	"./language/nd.svg": "8b10",
	"./language/ne.svg": "b75b",
	"./language/nl.svg": "74a5",
	"./language/nn.svg": "b339",
	"./language/no.svg": "d9d2",
	"./language/non.svg": "05ee",
	"./language/nr.svg": "0a95",
	"./language/ny.svg": "cb75",
	"./language/oc.svg": "35b1",
	"./language/om.svg": "8eed",
	"./language/or.svg": "a7e2",
	"./language/os.svg": "a218",
	"./language/oto.svg": "e0ca",
	"./language/pa.svg": "1ad7",
	"./language/pap.svg": "13d3",
	"./language/pl.svg": "94b7",
	"./language/ps.svg": "b91f",
	"./language/pt-br.svg": "c1d8",
	"./language/pt.svg": "6e73",
	"./language/qu.svg": "143f",
	"./language/rm.svg": "1eef",
	"./language/rn.svg": "d79b",
	"./language/ro.svg": "f9c4",
	"./language/ru.svg": "d4a5",
	"./language/rw.svg": "ea94",
	"./language/sc.svg": "2a11",
	"./language/sd.svg": "601c",
	"./language/se.svg": "5726",
	"./language/sg.svg": "b30b",
	"./language/si.svg": "ac98",
	"./language/sk.svg": "bca9",
	"./language/sl.svg": "c412",
	"./language/sm.svg": "3d4d",
	"./language/sn.svg": "9f12",
	"./language/so.svg": "ff1a",
	"./language/sq.svg": "f95d",
	"./language/sr.svg": "84e5",
	"./language/ss.svg": "b230",
	"./language/st.svg": "4aa7a",
	"./language/su.svg": "806b",
	"./language/sv.svg": "7440",
	"./language/sw.svg": "700b",
	"./language/ta.svg": "b13d",
	"./language/te.svg": "8c15",
	"./language/tg.svg": "4e0e",
	"./language/th.svg": "afe4",
	"./language/ti.svg": "14d0",
	"./language/tk.svg": "ca19",
	"./language/tl.svg": "63f8",
	"./language/tn.svg": "5c6f",
	"./language/to.svg": "cd4a",
	"./language/tr.svg": "5281",
	"./language/tt.svg": "9f49",
	"./language/ty.svg": "259b",
	"./language/udm.svg": "a0e4",
	"./language/ug.svg": "aaca",
	"./language/uk.svg": "84fa",
	"./language/ur.svg": "5bb2",
	"./language/uz.svg": "d5f5",
	"./language/vi.svg": "7e0a",
	"./language/vo.svg": "557c",
	"./language/xh.svg": "bd23",
	"./language/xx.svg": "979f",
	"./language/yi.svg": "7b8d",
	"./language/yo.svg": "8b96",
	"./language/yua.svg": "9801",
	"./language/zh.svg": "c56c",
	"./language/zu.svg": "4f9f",
	"./lb.svg": "3a82",
	"./lc.svg": "aa2f",
	"./li.svg": "1da4",
	"./lk.svg": "8ce5",
	"./lr.svg": "4fd2",
	"./ls.svg": "e541",
	"./lt.svg": "028a",
	"./lu.svg": "61c7",
	"./lv.svg": "8636",
	"./ly.svg": "f7b8",
	"./ma.svg": "a751",
	"./malayali.svg": "2cf6",
	"./manipur.svg": "9107",
	"./maori.svg": "eb4f",
	"./mc.svg": "7f86",
	"./md.svg": "2d54",
	"./me.svg": "d8fe",
	"./mf.svg": "ef4d",
	"./mg.svg": "2b73",
	"./mh.svg": "a4b1",
	"./mizoram.svg": "1b34",
	"./mk.svg": "d524",
	"./ml.svg": "45f9",
	"./mm.svg": "5e52",
	"./mn.svg": "cfa0",
	"./mo.svg": "a635",
	"./mp.svg": "30b8",
	"./mq.svg": "372e",
	"./mr.svg": "e573",
	"./ms.svg": "d08b",
	"./mt.svg": "126f",
	"./mu.svg": "d350",
	"./mv.svg": "7dd0",
	"./mw.svg": "fb2a",
	"./mx.svg": "3590",
	"./my.svg": "0941",
	"./mz.svg": "01d5",
	"./na.svg": "4c06",
	"./nato.svg": "de13",
	"./nc.svg": "995d",
	"./ne.svg": "561d",
	"./nf.svg": "ac8f",
	"./ng.svg": "74e1",
	"./ni.svg": "3a6b",
	"./nl-fr.svg": "5ef1",
	"./nl.svg": "84ab",
	"./no.svg": "185b",
	"./northern_cyprus.svg": "a6a7",
	"./np.svg": "291f",
	"./nr.svg": "0822",
	"./nu.svg": "888c",
	"./nz.svg": "d47b",
	"./occitania.svg": "a07b",
	"./olympics.svg": "0f50",
	"./om.svg": "5b27",
	"./otomi.svg": "c2a7",
	"./pa.svg": "9abc",
	"./pe.svg": "5742",
	"./pf.svg": "001e",
	"./pg.svg": "d9b7",
	"./ph.svg": "b052",
	"./pk-jk.svg": "765f",
	"./pk-sd.svg": "0cc2",
	"./pk.svg": "5f7a",
	"./pl.svg": "74ed",
	"./pm.svg": "e87a",
	"./pn.svg": "070c",
	"./pr.svg": "292d",
	"./ps.svg": "2c7e",
	"./pt-20.svg": "185be",
	"./pt-30.svg": "9fd0",
	"./pt.svg": "b96b",
	"./pw.svg": "8fc0",
	"./py.svg": "e5cc",
	"./qa.svg": "1639",
	"./quechua.svg": "97c1",
	"./re.svg": "09d9",
	"./ro.svg": "b550",
	"./rs.svg": "30f5",
	"./ru-ba.svg": "07a2",
	"./ru-ce.svg": "5ebd",
	"./ru-cu.svg": "33e7",
	"./ru-da.svg": "580a",
	"./ru-ko.svg": "a4d8",
	"./ru-ta.svg": "84f5",
	"./ru-ud.svg": "1e24",
	"./ru.svg": "e643",
	"./rw.svg": "a09f",
	"./sa.svg": "3820",
	"./sami.svg": "580a8",
	"./sb.svg": "0d36",
	"./sc.svg": "1b1a",
	"./sd.svg": "8713",
	"./se.svg": "400f",
	"./sg.svg": "0462",
	"./sh-ac.svg": "f2fd",
	"./sh-hl.svg": "61ee",
	"./sh-ta.svg": "a218c",
	"./sh.svg": "ad3e",
	"./si.svg": "28517",
	"./sj.svg": "0755",
	"./sk.svg": "b382",
	"./sl.svg": "9fbf",
	"./sm.svg": "63b6",
	"./sn.svg": "aa7b",
	"./so.svg": "7ee8",
	"./somaliland.svg": "e423",
	"./south_ossetia.svg": "3e924",
	"./soviet_union.svg": "f8c5",
	"./sr.svg": "7108",
	"./ss.svg": "2840",
	"./st.svg": "ae3e",
	"./su.svg": "acf5",
	"./sv.svg": "6315",
	"./sx.svg": "c578",
	"./sy.svg": "c389",
	"./sz.svg": "0df9",
	"./ta.svg": "6522",
	"./tc.svg": "1a7b",
	"./td.svg": "e04a",
	"./tf.svg": "c495",
	"./tg.svg": "47e3",
	"./th.svg": "2a14",
	"./tibet.svg": "8a9c",
	"./tj.svg": "0a12",
	"./tk.svg": "30c2",
	"./tl.svg": "2fb2",
	"./tm.svg": "7b74",
	"./tn.svg": "351c3",
	"./to.svg": "cb19",
	"./torres_strait_islands.svg": "dc65",
	"./tr.svg": "475f",
	"./transnistria.svg": "66b4",
	"./tt.svg": "d748",
	"./tv.svg": "3137",
	"./tw.svg": "525f",
	"./tz.svg": "7df0",
	"./ua.svg": "e899",
	"./ug.svg": "5546",
	"./uk.svg": "bc8f",
	"./um.svg": "2b8f",
	"./un.svg": "5aba",
	"./united_nations.svg": "748f",
	"./us-ak.svg": "6628",
	"./us-al.svg": "393b",
	"./us-ar.svg": "23ab",
	"./us-az.svg": "5d60",
	"./us-co.svg": "0134",
	"./us-fl.svg": "04c1",
	"./us-ga.svg": "fcef",
	"./us-hi.svg": "afd2",
	"./us-in.svg": "3684",
	"./us-mo.svg": "c4ec",
	"./us-ms.svg": "8c28",
	"./us-nm.svg": "fc87",
	"./us-tx.svg": "dc93",
	"./us.svg": "a6fe",
	"./uy.svg": "2fbc",
	"./uz.svg": "b9fe",
	"./va.svg": "2c8b",
	"./vc.svg": "1480",
	"./ve.svg": "89d3",
	"./vg.svg": "bc65",
	"./vi.svg": "2577",
	"./vn.svg": "e331",
	"./vu.svg": "8cd1",
	"./wf.svg": "84cc",
	"./wiphala.svg": "7e21",
	"./ws.svg": "468b",
	"./xk.svg": "e5b7",
	"./xx.svg": "5455",
	"./ye.svg": "b43d",
	"./yorubaland.svg": "5e0a",
	"./yt.svg": "f7a7",
	"./za.svg": "7a9a",
	"./zm.svg": "2600",
	"./zw.svg": "92f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";